/**
 * Explicit consent to process health data (allergies) — GDPR art. 9(2)(a).
 *
 * The version identifies the consent text the user accepted: the `preferences.healthConsent*`
 * keys in `app/src/i18n/locales/{ca,es,en}/legal.json`. Bump it whenever that text (or the
 * Privacy Policy it links to) changes in substance: stored consents with an older version no
 * longer count, so the Preferences screen asks again.
 */
export const HEALTH_DATA_CONSENT_VERSION = '2026-10-18'

/** True when a stored consent exists and was given for the current text. */
export function isHealthDataConsentCurrent(consent) {
    return Boolean(consent?.accepted) && consent?.version === HEALTH_DATA_CONSENT_VERSION
}
